
import React from 'react';
import './policies.css';

function ShippingDeliveryPolicy() {
  return (
    <div className="policy-page">
      <div className="policy-container">

        <h1>Shipping / Delivery Policy</h1>

        <p className="last-updated">
          Last Updated: june 2026
        </p>

        <div className="policy-welcome-box">
          <p>
            At <strong>Mr White</strong>, we strive to provide you with a seamless
            and convenient laundry service experience. This Shipping / Delivery
            Policy outlines our process for the pick-up and delivery of your
            laundry items.
          </p>
        </div>

        <div className="policy-section">
          <h2>1. Service Areas</h2>

          <p>
            We currently offer pick-up and delivery services in the following
            locations:
          </p>

          <ul className="policy-list">
            <li>Abu Dhabi</li>
            <li>Dubai</li>
            <li>Sharjah</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>2. Delivery Process</h2>

          <h3>Order Placement</h3>
          <p>
            After placing your order through our website or mobile application,
            you will receive a confirmation notification containing details of
            your selected services.
          </p>

          <h3>Pick-Up Scheduling</h3>
          <p>
            Within 2 hours, our team will contact you to schedule a convenient
            time for pick-up. Please ensure that you are available at the
            provided address during the selected time slot.
          </p>

          <h3>Laundry Processing</h3>
          <p>
            Once collected, your laundry items will be carefully handled and
            processed by our partner laundry facilities. Standard processing
            typically takes between 24 and 48 hours, depending on the services
            requested.
          </p>

          <h3>Delivery Scheduling</h3>
          <p>
            Once your laundry is ready, our team will contact you to arrange a
            suitable delivery time.
          </p>
        </div>

        <div className="policy-section">
          <h2>3. Delivery Timeframe</h2>

          <h3>Standard Delivery</h3>
          <p>
            After processing, your items will be delivered within 24–48 hours.
          </p>

          <h3>Express Delivery</h3>
          <p>
            If you choose our express service, your laundry will be delivered
            within 12 hours after processing.
          </p>
        </div>

        <div className="policy-section">
          <h2>4. Delivery Fees</h2>

          <p>
            We currently offer <strong>FREE delivery</strong> for all orders
            within our service areas.
          </p>
        </div>

        <div className="policy-section">
          <h2>5. Conditions</h2>

          <ul className="policy-list">
            <li>
              Ensure all items for pick-up are neatly packed and ready for
              collection at the agreed time.
            </li>

            <li>
              Mr White is not responsible for lost or damaged items that are
              not securely packed.
            </li>

            <li>
              If no one is available to receive the laundry during the scheduled
              delivery, a re-delivery fee of AED 4.99 may apply.
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>6. Contact Us</h2>

          <p>
            For questions, concerns, or special delivery requests, please
            contact our customer support team:
          </p>

          <p>
            <strong>Email:</strong>{' '}
            <a href="mailto:customercare@mrwhiteuae.com">
              customercare@mrwhiteuae.com
            </a>
          </p>

          <p>
            <strong>Phone:</strong>{' '}
            <a href="tel:+971585779343">
              +971 58 577 9343
            </a>
          </p>
        </div>

      </div>
    </div>
  );
}

export default ShippingDeliveryPolicy;

